import React, { useContext, useEffect, useRef, useState } from "react";
import JobDescription from "./JobDescription";
import { FaShare } from "react-icons/fa6";
import CommonContext from "../../hooks/CommonContext";
import { FaRegBookmark, FaBookmark } from "react-icons/fa6";
import { FiFilter } from "react-icons/fi";
import { IoMdClose } from "react-icons/io";
import HomeFilterForm from "../../components/Forms/HomeFilterForm";
import { call_chatbot_api } from "Slices/commonSlices/Chatbot_slice";
import { useDispatch } from "ReusableFunctions/CustomHooks";

const JobWorkSpaceRightContent = ({
    handleNoRequirementsApplyJob,
    handleSaveJob,
    handleReset,
    deviceResolution
}) => {
    let filterRef = useRef();
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const { isSmallDevice, applyFilterResponse,
        cardArray, selectedCardData,
        gettingResponse, selectedSkeleton,
        saveJobLoading, applyNowProfilePercent,
        isSelectedJob, isSharedJob
    } = useContext(CommonContext);

    useEffect(() => {
        const handler = (e) => {
            if (!e.target.closest('.filter-closet')) {
                setOpen(false)
            }
        }
        document.addEventListener("mousedown", handler);
        return () => {
            document.removeEventListener("mousedown", handler);
        }
    }, [])

    return (
        <>
            <div ref={filterRef} className={`${(isSelectedJob || isSharedJob) && isSmallDevice ? "col-12 h-100" : "col-12 col-lg-6 d-none d-lg-inline h-100"}`}>
                <div className="card w-100 border-0 bg-transparent h-100">
                    {
                        gettingResponse && !selectedSkeleton && !applyFilterResponse ?
                            selectedCardData.length === 0 || cardArray.length === 0 ?
                                <div className="row align-content-center h-100 justify-content-center">
                                    <p className="text-center">Oops! No Data Available</p>
                                </div>
                                :
                                <div className="card-body p-0">
                                    <div className={deviceResolution === "smallDevice" ? "col-12 bg-white p-2 py-3 rounded-top-4" : "col-12 JobDescription-sticky-top-height bg-white rounded-4"}>
                                        <div className="d-flex align-items-center my-2">
                                            <div className="flex-shrink-0 ms-2">
                                                <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${selectedCardData[0]?.profile_image !== undefined ? selectedCardData[0]?.profile_image : null}`} alt="..." width={72} height={72} className="rounded-circle objectContain" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <h3 className="job-heading text-break" data-testid='DataQualityManager'>{selectedCardData[0]?.job_title !== undefined ? selectedCardData[0]?.job_title : ''}</h3>
                                                <p className='company-name-fs mb-1'>{selectedCardData[0]?.company_name}</p>
                                                <p className="job-posted-on m-0">Posted on {selectedCardData[0]?.created_at !== undefined ? selectedCardData[0]?.created_at : ''}</p>
                                            </div>
                                        </div>
                                        <div className="d-flex">
                                            <div className="me-auto ms-5 p-2">
                                                {
                                                    selectedCardData[0]?.job_status === "Closed" || selectedCardData[0]?.job_status === "paused" || selectedCardData[0]?.job_status === "Paused" ?
                                                        <button className="btn pe-none jobclosed-text">
                                                            {
                                                                selectedCardData[0]?.job_status === "Closed" ? "Job Closed" : null ||
                                                                    selectedCardData[0]?.job_status === "paused" || selectedCardData[0]?.job_status === "Paused" ? "Job Paused" : null
                                                            }

                                                        </button>
                                                        :
                                                        selectedCardData[0]?.applied_status === "applied" ?
                                                            ["Closed", "paused"]?.includes(selectedCardData[0]?.job_status) ?
                                                                <button className="btn pe-none jobclosed-text">
                                                                    {
                                                                        selectedCardData[0]?.job_status === "Closed" ? "Job Closed" : null ||
                                                                            selectedCardData[0]?.job_status === "paused" || selectedCardData[0]?.job_status === "Paused" ? "Job Paused" : null
                                                                    }
                                                                </button>
                                                                :
                                                                <button className="btn btn-brand-color pe-none">Applied</button>
                                                            :
                                                            selectedCardData[0]?.required_resume === "Y" || selectedCardData[0]?.required_cover_letter === "Y" || (selectedCardData[0]?.questions[0] !== null && selectedCardData[0]?.questions.length > 0) ?
                                                                <button id="jobApplyNowWithResumeButton" className="btn btn-brand-color py-2"
                                                                    data-testid="ApplyNow"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target={applyNowProfilePercent >= 60 ? "#ApplyJobModal" : "#ApplyJobModalErrorBox"}
                                                                    onClick={applyNowProfilePercent >= 60 ?
                                                                        () => handleReset(selectedCardData)
                                                                        :
                                                                        null
                                                                    }> Apply Now</button>
                                                                :
                                                                <button id="jobApplyNowWithoutResumeButton" className="btn btn-brand-color py-2"
                                                                    data-bs-toggle={applyNowProfilePercent >= 60 ? null : "modal"}
                                                                    data-bs-target={applyNowProfilePercent >= 60 ? null : "#ApplyJobModalErrorBox"}
                                                                    onClick={applyNowProfilePercent >= 60 ?
                                                                        handleNoRequirementsApplyJob
                                                                        :
                                                                        null
                                                                    }>Apply Now</button>
                                                }
                                            </div>

                                            <div className="p-2">
                                                {
                                                    saveJobLoading ?

                                                        <button className="btn btn-secondary pe-none" type="button" disabled>
                                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                            <span className="ps-2 d-none d-lg-inline">Saving...</span>
                                                        </button>
                                                        :
                                                        selectedCardData[0]?.applied_status === "applied" || window.location.pathname === "/professional/saved_jobs" ?
                                                            null
                                                            :
                                                            selectedCardData[0]?.saved_status !== undefined ?

                                                                selectedCardData[0]?.saved_status === "saved" ?
                                                                    <button id="savedStatusSavedButton" type="button" className="btn btn-secondary pe-none d-flex align-items-center gap-2 py-2">
                                                                        <FaBookmark /> <span className="d-none d-lg-block">Saved</span>
                                                                    </button>
                                                                    :
                                                                    <button id="savedStatusSaveButton" type="button" className="btn btn-outline-secondary d-flex align-items-center gap-2 py-2" data-testid="Save" onClick={() => handleSaveJob(selectedCardData[0]?.id)}>
                                                                        <FaRegBookmark /> <span className="d-none d-lg-block">Save</span>
                                                                    </button>
                                                                :

                                                                <button id="undefinedSaveButton" type="button" className="btn btn-outline-secondary d-flex align-items-center gap-2 py-2" data-testid="Save" onClick={() => handleSaveJob(selectedCardData[0]?.id)}>
                                                                    <FaRegBookmark /> <span className="d-none d-lg-block">Save</span>
                                                                </button>
                                                }
                                            </div>

                                            {
                                                selectedCardData[0]?.job_status === "opened" || selectedCardData[0]?.job_status === "Opened" || selectedCardData[0]?.job_status === undefined ?
                                                    <div className="p-2">
                                                        <button id="jobShareButton" type="button" className="btn btn-outline-secondary d-flex align-items-center gap-1 py-2" data-testid="Share" data-bs-toggle="modal" data-bs-target="#shareModal">
                                                            <FaShare /> <span className="d-none d-lg-block">Share</span>
                                                        </button>
                                                    </div>
                                                    :
                                                    null
                                            }
                                        </div>
                                    </div>

                                    <JobDescription deviceResolution={deviceResolution} />
                                </div>
                            :
                            null
                    }

                    {gettingResponse === false || selectedSkeleton || applyFilterResponse ?
                        <div className="card-body p-0">
                            <div className={deviceResolution === "smallDevice" ?
                                "col-12 bg-white p-2  rounded-top-4"
                                :
                                "col-12 JobDescription-sticky-top-height bg-white rounded-4"}>

                                <div className="d-flex align-items-center my-2">
                                    <div className="flex-shrink-0 ms-2">
                                        <img src={``} alt="placeholder image" width={50} height={50} className='pe-none placeholder rounded-circle' />
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                        <p className="job-posted-on placeholder rounded col-5 py-2 pt-3"></p>
                                        <h3 className="job-heading placeholder rounded col-8 py-2"></h3>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div className="me-auto ms-5 p-2">
                                        <button className="btn btn-outline-secondary ms-3 placeholder px-5 pe-none"></button>
                                    </div>
                                    <div className="p-2">
                                        <button className="btn btn-outline-secondary placeholder px-5"></button>
                                    </div>
                                    <div className="p-2">
                                        <button className="btn btn-outline-secondary placeholder px-5"></button>
                                    </div>
                                </div>
                            </div>

                            <JobDescription />
                        </div>
                        :
                        null
                    }
                </div>
            </div>

            <div className={`${open ? 'responsive-filter d-xxl-none ' : 'd-none'}`} id="myModal">
                <div className="responsive-filter-card filter-closet">
                    <header>
                        <h2 className='m-0 text-start ps-3'>Filter</h2>
                        <p className=" close-icon responsive-filter-close-icon" onClick={() => setOpen(!open)}><IoMdClose /></p>
                    </header>

                    <div className="filter-body-content ">
                        <HomeFilterForm />
                    </div>
                </div>
            </div>

            {window.location.pathname === "/professional/all_jobs" && !deviceResolution ?
                <div className="responsive-filter-toggler d-xxl-none">
                    {open ?
                        <p className="material-symbols-outlined mb-0" onClick={() => setOpen(!open)} id="close_mobile_filter">< IoMdClose /></p>
                        :
                        <p className="material-symbols-outlined  mb-0" onClick={() => {
                            dispatch(call_chatbot_api({ type: 'minimize_chatbot', show: true }))
                            setOpen(!open)
                        }}><  FiFilter /></p>
                    }
                </div>
                :
                null
            }
        </>
    )
}

export default JobWorkSpaceRightContent